export default {
  'name': '@okta/okta-vue',
  'version': '1.3.0'
};



// WEBPACK FOOTER //
// webpack:///src/packageInfo.js